import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const RELOCATION_ORDER_DELETE_RESOURCE = "relocation-order" as const;
export const RELOCATION_ORDER_DELETE_API_PATH = `/v1/${RELOCATION_ORDER_DELETE_RESOURCE}/{uuid}` as const;

export type RelocationOrderDeleteResponse =
  paths[typeof RELOCATION_ORDER_DELETE_API_PATH]["delete"]["responses"][200]["content"]["application/json"];

export const useRelocationOrderDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<RelocationOrderDeleteResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.delete<RelocationOrderDeleteResponse>(
        `/v1/${RELOCATION_ORDER_DELETE_RESOURCE}/${uuid}`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [RELOCATION_ORDER_DELETE_RESOURCE],
      });
    },
  });
};
